import { Link } from "react-router-dom";
import { PageHero } from "../../components/PageHero";
import { ScrollReveal } from "../../components/ScrollReveal";
import { Seo } from "../../components/Seo";
import { useLanguage } from "../../i18n/LanguageProvider";

/** Research and assessment openings from the revised content document. */
export const CareersPage = () => {
  const { t, tList, path } = useLanguage();

  return (
    <>
      <Seo
        titleKey="meta.careers.title"
        descriptionKey="meta.careers.description"
      />

      <PageHero
        variant="careers"
        eyebrow={t("careers.eyebrow")}
        title={t("careers.title")}
        subtitle={t("careers.subtitle")}
      />

      <section className="gw-section">
        <div className="gw-container">
          <ScrollReveal>
            <h2 className="gw-title">{t("careers.agendaHeading")}</h2>
            <ul className="gw-pill-list" style={{ marginTop: "1.25rem" }}>
              {tList("careers.agenda").map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </ScrollReveal>

          <div
            className="gw-grid gw-grid--2"
            style={{ alignItems: "start", marginTop: "3rem" }}
          >
            <ScrollReveal direction="left">
              <div className="gw-card" style={{ padding: "var(--gw-space-6)" }}>
                <h2 style={{ fontSize: "var(--gw-text-lg)" }}>
                  {t("careers.contributeHeading")}
                </h2>
                <ul
                  className="gw-stack"
                  style={{
                    marginTop: "1rem",
                    paddingInlineStart: "1.2rem",
                    color: "var(--gw-ink-muted)",
                  }}
                >
                  {tList("careers.contribute").map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </ScrollReveal>

            <ScrollReveal direction="right" delay={100}>
              <div className="gw-stack-lg">
                <div>
                  <h2 style={{ fontSize: "var(--gw-text-lg)" }}>
                    {t("careers.backgroundHeading")}
                  </h2>
                  <p
                    style={{
                      marginTop: "0.6rem",
                      color: "var(--gw-ink-muted)",
                    }}
                  >
                    {t("careers.backgroundBody")}
                  </p>
                </div>
                <div>
                  <h2 style={{ fontSize: "var(--gw-text-lg)" }}>
                    {t("careers.arrangementsHeading")}
                  </h2>
                  <p
                    style={{
                      marginTop: "0.6rem",
                      color: "var(--gw-ink-muted)",
                    }}
                  >
                    {t("careers.arrangementsBody")}
                  </p>
                  <ul className="gw-pill-list" style={{ marginTop: "0.9rem" }}>
                    {tList("careers.arrangements").map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <section className="gw-section gw-section--sunken">
        <div className="gw-container gw-container--narrow">
          <ScrollReveal>
            <h2 className="gw-title">{t("careers.goalHeading")}</h2>
            <p className="gw-lead">{t("careers.goalBody")}</p>
          </ScrollReveal>
        </div>
      </section>

      <section className="gw-section gw-section--gradient">
        <div
          className="gw-container gw-container--narrow"
          style={{ textAlign: "center" }}
        >
          <ScrollReveal>
            <h2 className="gw-title">{t("careers.ctaTitle")}</h2>
            <p className="gw-subtitle" style={{ marginInline: "auto" }}>
              {t("careers.ctaBody")}
            </p>
            <div
              className="gw-hero__actions"
              style={{ justifyContent: "center", marginTop: "2rem" }}
            >
              <Link to={path("/contact")} className="gw-btn gw-btn--on-dark">
                {t("careers.ctaButton")}
              </Link>
              <Link
                to={path("/sign-up")}
                className="gw-btn gw-btn--secondary"
                style={{ color: "#fff", borderColor: "rgb(255 255 255 / 45%)" }}
              >
                {t("careers.ctaSecondary")}
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </>
  );
};
